import { useTranslation } from "react-i18next";
import SwitchView from "./SwitchView";
import DrugsGraph from "./DrugsGraph";
import {Consts} from "../pages/consts";
import React, {useContext} from "react";
import InitContext from "../pages/InitContext";

const GraphView = ({ selectedDrug, patDrugs, setDrugsView, nodes, edges, handleSelected }) => {
  const { t } = useTranslation();
  const context = useContext(InitContext);

  const myDrug = selectedDrug?.id
    ? selectedDrug
    : patDrugs?.length > 0 ? patDrugs[0] : selectedDrug;

  return (
    <>
      {context?.role !== Consts.PATIENT ? (
        <>
          <div className="w3-right w3-margin-right">
            <SwitchView
              setDrugsView={setDrugsView}
              viewName={Consts.TABLE}
              label={t("to_tabular_view")}
            />
          </div>
          <DrugsGraph
            selectedDrug={myDrug}
            nodes={nodes}
            edges={edges}
            handleSelected={handleSelected}
          />
        </>
      ) : (
        <div className="w3-display-container content-container">
          <div style={{ width: '100%', textAlign: 'right', paddingRight: "20px" }}>
            <label>{t("username")}: {context?.patient?.login}, {t("role")}: {t("patient").toLowerCase()}</label>
          </div>
          <div className="w3-display-middle w3-center form-display">
            <div className="w3-panel w3-card-4 record-panel">
              <div className="w3-container w3-padding-small w3-right">
                <SwitchView
                  setDrugsView={setDrugsView}
                  viewName={Consts.TABLE}
                  label={t("to_tabular_view")}
                />
              </div>
              <DrugsGraph
                selectedDrug={myDrug}
                nodes={nodes}
                edges={edges}
                handleSelected={handleSelected}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GraphView;
